import { useState, useEffect } from 'react';

// Session-scoped persisted state: survives tab navigation, cleared on page refresh.
// A fresh session id is written on every full page load (index bootstrap below).
if (!window.__npdSession) {
  window.__npdSession = Date.now().toString(36);
  // wipe previous session's keys
  Object.keys(sessionStorage).forEach(k => { if (k.startsWith('nps:')) sessionStorage.removeItem(k); });
}

export default function usePersistedState(key, initial) {
  const full = 'nps:' + key;
  const [val, setVal] = useState(() => {
    try {
      const raw = sessionStorage.getItem(full);
      return raw !== null ? JSON.parse(raw) : initial;
    } catch { return initial; }
  });
  useEffect(() => {
    try { sessionStorage.setItem(full, JSON.stringify(val)); } catch {}
  }, [full, val]);
  return [val, setVal];
}
